// @ts-nocheck
import React, { useState } from 'react';
import { submitContactForm } from '../services/api';

export default function HelpSupportContent({ roleLabel = 'User' }: any) {
  const [showContactForm, setShowContactForm] = useState<any>(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState<any>(false);
  const [submitResult, setSubmitResult] = useState<any>(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setSubmitResult({ success: false, message: 'Please fill all fields' });
      return;
    }

    setSubmitting(true);
    setSubmitResult(null);

    try {
      const result = await submitContactForm(formData);
      setSubmitResult({ success: true, message: result.message });
      setFormData({ name: '', email: '', subject: '', message: '' });
      setShowContactForm(false);
      setTimeout(() => setSubmitResult(null), 5000);
    } catch (err: any) {
      setSubmitResult({ 
        success: false, 
        message: 'Failed to submit form. Please try again.' 
      });
    } finally {
      setSubmitting(false);
    }
  };

  const containerStyle = {
    padding: 20,
    maxWidth: 1000,
    margin: '0 auto',
  };

  const headerStyle = {
    marginBottom: 32,
  };

  const sectionStyle = {
    marginBottom: 28,
    padding: 20,
    background: 'var(--ae-surface)',
    borderRadius: 14,
    border: '1px solid var(--ae-border)',
    boxShadow: 'var(--ae-shadow-card)',
  };

  // Removed unused contactBoxStyle, contactTextStyle, emailLinkStyle

  const buttonStyle = {
    padding: '10px 16px',
    background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
    color: '#ffffff',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 700,
    marginTop: 12,
    boxShadow: 'var(--ae-shadow-card)',
  };

  const formContainerStyle = {
    background: 'var(--ae-surface)',
    border: '1px solid var(--ae-border)',
    borderRadius: 14,
    padding: 20,
    marginTop: 16,
    boxShadow: 'var(--ae-shadow-card)',
  };

  const formGroupStyle = {
    marginBottom: 16,
  };

  const labelStyle = {
    display: 'block',
    marginBottom: 6,
    fontWeight: 600,
    color: 'var(--ae-primary-strong)',
    fontSize: 14,
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid var(--ae-border)',
    borderRadius: 8,
    fontSize: 14,
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: 120,
    resize: 'vertical',
    fontFamily: 'inherit',
  };

  const submitButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(135deg, #159987 0%, #1fb29a 100%)',
    width: '100%',
    padding: '12px 16px',
    marginTop: 0,
  };

  const cancelButtonStyle = {
    ...buttonStyle,
    background: '#6b7280',
    marginLeft: 8,
  };

  const messageStyle = {
    padding: 12,
    borderRadius: 8,
    marginBottom: 12,
    fontSize: 14,
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={{ fontSize: 30, fontWeight: 800, marginBottom: 8, color: 'var(--ae-primary-strong)' }}>Help & Support</h1>
        <p style={{ fontSize: 16, color: 'var(--ae-text-muted)' }}>We're here to help! Contact us with any questions or feedback.</p>
      </div>

      {/* Academic Eye Overview Video Section */}
      <div style={{
        ...sectionStyle,
        background: 'var(--ae-surface)',
        border: '1px solid var(--ae-border)',
        boxShadow: 'var(--ae-shadow-soft)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: 24,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <div style={{ width: 40, height: 40, display: 'grid', placeItems: 'center', flex: '0 0 auto', borderRadius: 10, background: '#dbeafe', color: '#1d4ed8', fontSize: 20 }}>▶</div>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--ae-primary-strong)', margin: 0 }}>Academic Eye Overview Video</h2>
        </div>
        <p style={{ color: '#374151', marginBottom: 18, fontSize: 15, maxWidth: 640 }}>
          Watch a comprehensive walkthrough of Academic Eye to learn about key features, workflows, and tools across the platform.
        </p>
        <a
          href="https://canva.link/qtek6v9wzkiokc4"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
            color: 'white',
            fontWeight: 700,
            padding: '10px 22px',
            borderRadius: 8,
            textDecoration: 'none',
            fontSize: 15,
            boxShadow: '0 2px 8px #0001',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <span role="img" aria-label="Play">▶️</span> Watch Overview Video ↗
        </a>
      </div>

      {/* Teacher Account Overview PDF Section */}
      <div style={{
        ...sectionStyle,
        background: 'var(--ae-surface)',
        border: '1px solid var(--ae-border)',
        boxShadow: 'var(--ae-shadow-soft)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: 32,
      }}>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--ae-primary-strong)', marginBottom: 8 }}>Teacher Account Overview</h2>
        <p style={{ color: '#374151', marginBottom: 18, fontSize: 15, maxWidth: 600 }}>
          Access step-by-step instructions and guidance for using your Academic Eye teacher account. You can view the PDF in your browser or download it for reference.
        </p>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 4 }}>
          <a
            href="/Teacher%20Account%20Overview.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: 'linear-gradient(135deg, var(--ae-primary) 0%, #2f66c9 100%)',
              color: 'white',
              fontWeight: 700,
              padding: '10px 22px',
              borderRadius: 8,
              textDecoration: 'none',
              fontSize: 15,
              boxShadow: '0 2px 8px #0001',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <span role="img" aria-label="View">👁️</span> View PDF
          </a>
          <a
            href="/Teacher%20Account%20Overview.pdf"
            download
            style={{
              background: 'linear-gradient(135deg, #159987 0%, #1fb29a 100%)',
              color: 'white',
              fontWeight: 700,
              padding: '10px 22px',
              borderRadius: 8,
              textDecoration: 'none',
              fontSize: 15,
              boxShadow: '0 2px 8px #0001',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <span role="img" aria-label="Download">⬇️</span> Download PDF
          </a>
        </div>
      </div>

      {/* Contact Form Trigger */}
      {!showContactForm && (
        <button onClick={() => setShowContactForm(true)} style={buttonStyle}>
          Send us a Message
        </button>
      )}

      {/* Submission Result Message */}
      {submitResult && (
        <div style={{
          ...messageStyle,
          background: submitResult.success ? '#dcfce7' : '#fee2e2',
          color: submitResult.success ? '#166534' : '#991b1b',
          border: `1px solid ${submitResult.success ? '#bbf7d0' : '#fecaca'}`,
        }}>
          {submitResult.message}
        </div>
      )}

      {/* Contact Form */}
      {showContactForm && (
        <div style={formContainerStyle}>
          <h3 style={{ marginTop: 0, marginBottom: 16, fontSize: 18, fontWeight: 600 }}>Send us a Message</h3>
          <form onSubmit={handleSubmit}>
            <div style={formGroupStyle}>
              <label style={labelStyle}>Your Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                style={inputStyle}
              />
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle}>Your Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email address"
                style={inputStyle}
              />
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle}>Subject *</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                placeholder="What is this about?"
                style={inputStyle}
              />
            </div>

            <div style={formGroupStyle}>
              <label style={labelStyle}>Message *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Please describe your question or feedback in detail..."
                style={textareaStyle}
              />
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button
                type="submit"
                disabled={submitting}
                style={{
                  ...submitButtonStyle,
                  opacity: submitting ? 0.6 : 1,
                  cursor: submitting ? 'not-allowed' : 'pointer',
                }}
              >
                {submitting ? 'Sending...' : 'Send Message'}
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowContactForm(false);
                  setFormData({ name: '', email: '', subject: '', message: '' });
                }}
                style={cancelButtonStyle}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div style={sectionStyle}>
        <h2 style={{ marginTop: 0, fontSize: 20, fontWeight: 600, marginBottom: 12 }}>Privacy</h2>
        <p style={{ marginTop: 0, color: 'var(--ae-text-muted)', marginBottom: 12 }}>
          Read how Academic Eye collects, uses, and protects student and family information under FERPA and COPPA (school channel).
        </p>
        <a
          href="/privacy"
          style={{ color: 'var(--ae-primary-strong, #2563eb)', fontWeight: 700, textDecoration: 'underline' }}
        >
          Privacy Policy
        </a>
      </div>

      {/* FAQ Section */}
      <div style={sectionStyle}>
        <h2 style={{ marginTop: 0, fontSize: 20, fontWeight: 600, marginBottom: 16 }}>Frequently Asked Questions</h2>
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ marginTop: 0, marginBottom: 8, color: '#1f2937', fontSize: 16 }}>How do I reset my password?</h3>
          <p style={{ marginTop: 0, color: 'var(--ae-text-muted)' }}>
            Click on "Forgot Password" on the login page and follow the instructions sent to your email.
          </p>
        </div>
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ marginTop: 0, marginBottom: 8, color: '#1f2937', fontSize: 16 }}>Who do I contact for technical issues?</h3>
          <p style={{ marginTop: 0, color: 'var(--ae-text-muted)' }}>
            Please email ashley@academiceye.net with details about the issue you're experiencing.
          </p>
        </div>
        <div style={{ marginBottom: 0 }}>
          <h3 style={{ marginTop: 0, marginBottom: 8, color: '#1f2937', fontSize: 16 }}>Can I provide feedback or suggestions?</h3>
          <p style={{ marginTop: 0, color: 'var(--ae-text-muted)' }}>
            Absolutely! We'd love to hear your feedback. Use the contact form above or email us directly at ashley@academiceye.net
          </p>
        </div>
      </div>

      {/* Support Hours */}
      <div style={sectionStyle}>
        <h2 style={{ marginTop: 0, fontSize: 20, fontWeight: 600, marginBottom: 12 }}>Support Hours</h2>
        <p style={{ marginTop: 0, color: 'var(--ae-text-muted)' }}>
          We aim to respond to all inquiries within 24 business hours. For urgent technical issues, please mark them as such in your email subject line.
        </p>
      </div>
    </div>
  );
}
